import { isFuture as isFutureDateFns } from 'date-fns';

import { parseDateString } from './parseDateString';

export const isFuture = (dateString) => {
  const date = parseDateString(dateString);

  return isFutureDateFns(date);
};
